// extracted by mini-css-extract-plugin
export default {"InviteCandidateButton":"styles_InviteCandidateButton__Mcdgc"};